import {
  LitElement,
  html,
  css,
  classMap,
  broadcastReceiver,
} from '@hh/global.js'

class HHMobileMenu extends LitElement {
  static properties = {
    open: {
      type: Boolean,
      reflect: true,
    },
    activeFirstLevel: {
      type: String,
    },
  }

  constructor() {
    super()

    this.classes = {
      active: 'active',
    };

    window.addEventListener('DOMContentLoaded', function() {
      const menu = document.getElementById('main-menu');
      if (menu) {
        menu.focus();
      }
    });

    this.handleEscapeKey = this.handleEscapeKey.bind(this);
  }

  handleArrowKeys(e) {
    if (!['ArrowDown', 'ArrowRight', 'ArrowUp', 'ArrowLeft', 'Home', 'End', 'Tab'].includes(e.key)) {
      return;
    }

    const firstLevelButtons = Array.from(this.firstLevelButtons);
    const secondLevelButtons = Array.from(this.activeSecondLevelsButtons);
    const thirdLevelButtons = Array.from(this.activeThirdLevelsButtons);

    const currentFocused = this.focusedElement;
    const closeButton = document.querySelector('button.mobile-menu__close');
    const isCloseButtonFocused = document.activeElement === closeButton;

    const isCurrentFocusedOnFirstLevel = firstLevelButtons.filter(button => button === currentFocused).length > 0;
    const isCurrentFocusedOnSecondLevel = secondLevelButtons.filter(button => button === currentFocused).length > 0;
    const isCurrentFocusedOnThirdLevel = thirdLevelButtons.filter(button => button === currentFocused).length > 0;
    
    //first level menu arrows navigation
    if (isCurrentFocusedOnFirstLevel && e.key === 'ArrowDown' && secondLevelButtons[0]) {
      secondLevelButtons[0].focus();
    }
    if (isCurrentFocusedOnFirstLevel && e.key === 'ArrowDown' && thirdLevelButtons[0]) {
      thirdLevelButtons[0].focus();
    }

    if (isCurrentFocusedOnFirstLevel && e.key === 'ArrowUp') {
      closeButton.focus();
    }

    if (isCurrentFocusedOnFirstLevel && e.key === 'ArrowRight' ) {
      const currentIndex = firstLevelButtons.indexOf(currentFocused);
      let nextIndex = currentIndex + 1;

      if (nextIndex >= firstLevelButtons.length) {
        nextIndex = 0;
      }

      firstLevelButtons[nextIndex].focus();
    }

    if (isCurrentFocusedOnFirstLevel && e.key === 'ArrowLeft') {
      const currentIndex = firstLevelButtons.indexOf(currentFocused);
      let prevIndex = currentIndex - 1;
    
      if (prevIndex < 0) {
        prevIndex = firstLevelButtons.length - 1;
      }
    
      firstLevelButtons[prevIndex].focus();
    }

    if (e.key === 'Home' && isCurrentFocusedOnFirstLevel) {
      firstLevelButtons[0].focus();
    }
    if (e.key === 'End' && isCurrentFocusedOnFirstLevel) {
      firstLevelButtons[firstLevelButtons.length - 1].focus();
    }

    //second level menu arrows navigation
    if (isCurrentFocusedOnSecondLevel && e.key === 'ArrowDown') {
      const currentIndex = secondLevelButtons.indexOf(currentFocused);
      let nextIndex = currentIndex + 1;
    
      if (nextIndex >= secondLevelButtons.length) {
        firstLevelButtons[0].focus();
      } else {
        secondLevelButtons[nextIndex].focus();
      }
    }
    
    if (isCurrentFocusedOnSecondLevel && e.key === 'ArrowUp') {
      const currentIndex = secondLevelButtons.indexOf(currentFocused);
      let prevIndex = currentIndex - 1;
    
      if (prevIndex < 0) {
        firstLevelButtons[0].focus();
      } else {
        secondLevelButtons[prevIndex].focus();
      }
    }

    if (e.key === 'Home' && isCurrentFocusedOnSecondLevel) {
      secondLevelButtons[0].focus();
    }
    if (e.key === 'End' && isCurrentFocusedOnSecondLevel) {
      secondLevelButtons[secondLevelButtons.length - 1].focus();
    }

    //third level menu arrows navigation
    if (isCurrentFocusedOnThirdLevel && e.key === 'ArrowDown') {
      const currentIndex = thirdLevelButtons.indexOf(currentFocused);
      let nextIndex = currentIndex + 1;

      if (nextIndex >= thirdLevelButtons.length) {
        firstLevelButtons[0].focus();
      } else {
        thirdLevelButtons[nextIndex].focus();
      }
    }

    if (isCurrentFocusedOnThirdLevel && e.key === 'ArrowUp') {
      const currentIndex = thirdLevelButtons.indexOf(currentFocused);
      let prevIndex = currentIndex - 1;

      if (prevIndex < 0) {
        firstLevelButtons[0].focus();
      } else {
        thirdLevelButtons[prevIndex].focus();
      }
    }

    if (isCloseButtonFocused && e.key === 'ArrowDown') {
      firstLevelButtons[0].focus();
    }

    if (e.key === 'Home' && isCurrentFocusedOnThirdLevel) {
      thirdLevelButtons[0].focus();
    }
    if (e.key === 'End' && isCurrentFocusedOnThirdLevel) {
      thirdLevelButtons[thirdLevelButtons.length - 1].focus();
    }

    //handling tab inside first level
    if (isCurrentFocusedOnFirstLevel && e.key === 'Tab' && !e.shiftKey) {
      e.preventDefault();

      const currentIndex = firstLevelButtons.indexOf(currentFocused);

      if (currentIndex+1 <= firstLevelButtons.length - 1) {
        firstLevelButtons[currentIndex + 1].focus();
      } else if (secondLevelButtons.length > 0){
          secondLevelButtons[0].focus();
      } else if (thirdLevelButtons.length > 0){
        thirdLevelButtons[0].focus();
      }
    }

    if (isCurrentFocusedOnFirstLevel && e.key === 'Tab' && e.shiftKey) {
      e.preventDefault();

      const currentIndex = firstLevelButtons.indexOf(currentFocused);
      if (currentIndex - 1 >= 0) {
        firstLevelButtons[currentIndex - 1].focus();
      } else {
        closeButton.focus();
      }
    }

    if (isCloseButtonFocused && e.key === 'Tab' && isCloseButtonFocused) {
      e.preventDefault();
      firstLevelButtons[0].focus();
    }

    //handling tab inside second level
    if (isCurrentFocusedOnSecondLevel && e.key === 'Tab' && !e.shiftKey) {
      e.preventDefault();

      const currentIndex = secondLevelButtons.indexOf(currentFocused);
      if (currentIndex + 1 <= secondLevelButtons.length - 1) {
        secondLevelButtons[currentIndex + 1].focus();
      }
      if (currentIndex === secondLevelButtons.length - 1) {
        firstLevelButtons[0].focus();
      }
    }

    if (isCurrentFocusedOnSecondLevel && e.key === 'Tab' && e.shiftKey) {
      e.preventDefault();

      const currentIndex = secondLevelButtons.indexOf(currentFocused);
      if (currentIndex - 1 < 0) {
        firstLevelButtons[0].focus();
      } else {
        secondLevelButtons[currentIndex - 1].focus();
      }
    }

    //handling tab inside third level
    if (isCurrentFocusedOnThirdLevel && e.key === 'Tab' && !e.shiftKey) {
      e.preventDefault();

      const currentIndex = thirdLevelButtons.indexOf(currentFocused);
      if (currentIndex + 1 <= thirdLevelButtons.length - 1) {
        thirdLevelButtons[currentIndex + 1].focus();
      }
      if (currentIndex === thirdLevelButtons.length - 1) {
        firstLevelButtons[0].focus();
      }
    }

    if (isCurrentFocusedOnThirdLevel && e.key === 'Tab' && e.shiftKey) {
      e.preventDefault();

      const currentIndex = thirdLevelButtons.indexOf(currentFocused);
      if (currentIndex - 1 < 0) {
        firstLevelButtons[0].focus();
      } else {
        thirdLevelButtons[currentIndex - 1].focus();
      }
    }
  }

  get focusedElement() {
    return this.shadowRoot?.activeElement || document.activeElement;
  }

  /* getters */
  get header() {
    return document.querySelector('.js-header') ?? null
  }

  get announcementBar() {
    return document.querySelector('.js-announcement-bar-section') ?? null
  }

  get menuOpener() {
    return document.getElementById('mobile-menu-opener') ?? null
  }

  get menu() {
    return this.shadowRoot.querySelector('.menu') ?? null
  }

  get firstLevel() {
    const slot = this.shadowRoot?.querySelector(`slot[name='first-level']`)
    return slot?.assignedNodes()[0] ?? null
  }

  get firstLevelButtons() {
    return this.firstLevel?.querySelectorAll('button') ?? []
  }

  get secondLevels() {
    const slot = this.shadowRoot?.querySelector(`slot[name='second-level']`)
    return slot?.assignedNodes() ?? []
  }

  get secondLevelsButtons() {
    return this.secondLevels
      .map((slot) => [...slot.querySelectorAll('button, a')])
      .flat()
  }

  get thirdLevels() {
    const slot = this.shadowRoot?.querySelector(`slot[name='third-level']`)
    return slot?.assignedNodes() ?? []
  }

  get thirdLevelsButtons() {
    return this.thirdLevels
      .map((slot) => [...slot.querySelectorAll('button, a')])
      .flat()
  }
  
  get activeSecondLevels() {
    const slot = this.shadowRoot?.querySelector(`slot[name='second-level']`);
    return (slot?.assignedElements() ?? []).filter(el => el.getAttribute('aria-hidden') !== 'true');
  }  

  get activeSecondLevelsButtons() {
    return this.activeSecondLevels
      .map((slot) => [...slot.querySelectorAll('button, a')])
      .flat()
  }

  get activeThirdLevels() {
    const slot = this.shadowRoot?.querySelector(`slot[name='third-level']`);
    return (slot?.assignedElements() ?? []).filter(el => el.getAttribute('aria-hidden') !== 'true');
  }  

  get activeThirdLevelsButtons() {
    return this.activeThirdLevels
      .map((slot) => [...slot.querySelectorAll('button, a')])
      .flat()
  }

  connectedCallback() {
    super.connectedCallback()

    this.openReceiver = broadcastReceiver(
      'mobile-menu:open',
      this.openFromDocument.bind(this)
    )
    this.closeReceiver = broadcastReceiver(
      'mobile-menu:close',
      this.closeMenuClicked.bind(this)
    )

    window.addEventListener('search:opened', this.closeFromDocument.bind(this))
    this.handleArrowKeys = this.handleArrowKeys.bind(this); 
  }

  disconnectedCallback() {
    super.disconnectedCallback()

    this.openReceiver.disconnect()
    this.closeReceiver.disconnect()
    window.removeEventListener('search:opened', this.closeFromDocument)
  }

  firstUpdated() {
    this.setDefaultFirstLevel()
  }

  updated(changedProperties) {
    if (changedProperties.has('open')) {
      if (this.open) {
        this.emiMobileMenuOpenEvent()
        document.documentElement.classList.add(
          'overflow-hidden',
          'mobile-menu-open'
        )

        document.addEventListener('keydown', this.handleEscapeKey);
        document.addEventListener('keydown', this.handleArrowKeys);
      } else {
        document.documentElement.classList.remove(
          'overflow-hidden',
          'mobile-menu-open'
        );

        document.removeEventListener('keydown', this.handleEscapeKey);
        document.removeEventListener('keydown', this.handleArrowKeys);
      }
    }

    if (changedProperties.has('activeFirstLevel')) {
      this.updateSecondLevel(this.activeFirstLevel)
    }

    this.updateAreaHiddenAttributes();
  }

  handleEscapeKey(e) {
    if (e.key === 'Escape') {
      this.closeMenuClicked();
    }
  }

  async openFromDocument() {
    await this.updateHeaderHeight()
    this.open = true
    this.menuOpener?.setAttribute('aria-expanded', 'true')
    document.body.classList.add('mobile-menu-open')

    this.firstLevel.setAttribute('tabindex', '0')
    setTimeout(() => {
      this.firstLevel.focus()
      this.firstLevelButtons[0].focus();
      this.firstLevel.removeAttribute('tabindex')
    }, 0)
  }

  closeFromDocument() {
    this.open = false
    document.body.classList.remove('mobile-menu-open')
    this.menuOpener?.setAttribute('aria-expanded', 'false')
    setTimeout(() => {
      this.setDefaultFirstLevel();
      this.removeThirdLevelActive();
    }, 0)
  }

  closeMenuClicked() {
    const expandedFirstLevelItem = document.querySelector('.mobile-menu__first-level-button[aria-expanded="true"]');
    const expandedSecondLevelItem = document.querySelector('.mobile-menu__second-level-button[aria-expanded="true"]');

    if (expandedFirstLevelItem !== null && expandedSecondLevelItem !== null) {
      expandedFirstLevelItem.click();
      setTimeout(() => {expandedSecondLevelItem.focus();}, 0);
    } else {
      this.closeFromDocument();
      this.focusOnMenuOpener();
    }

    this.updateAreaHiddenAttributes();
  }

  focusOnMenuOpener() {
    setTimeout(() => {
      const mobileMenuOpener = document.querySelector('#mobile-menu-opener');
      mobileMenuOpener.focus();
    }, 0);
  }

  emiMobileMenuOpenEvent() {
    this.dispatchEvent(
      new CustomEvent('mobile-menu:opened', {
        bubbles: true,
        composed: true,
      })
    )
  }

  updateHeaderHeight() {
    return new Promise((resolve) => {
      this.headerHeight = this.header.offsetHeight
      this.announcementBarHeight = this.announcementBar?.offsetHeight || 0
      this.totalHeaderHeight = this.headerHeight + this.announcementBarHeight

      HH.setCSSVariable(
        '--hh-total-header-height',
        `${this.totalHeaderHeight}px`
      )
      resolve()
    })
  }

  onFirstLevelClick(e) {
    e.preventDefault()
    const { target } = e
    const { menu } = target.dataset
    this.firstLevelButtons.forEach((button) => {
      button.classList.remove(this.classes.active)
      button.setAttribute('aria-expanded', 'false')
    })
    target.classList.add(this.classes.active)
    target.setAttribute('aria-expanded', 'true')
    this.activeFirstLevel = menu
    this.removeThirdLevelActive()
  }

  setDefaultFirstLevel() {
    const activeMenu = this.firstLevelButtons[0];
    activeMenu.click();
  }

  updateSecondLevel(menu) {
    this.secondLevels.forEach((secondLevel) =>
      secondLevel.classList.remove(this.classes.active)
    )
    const activeMenu = this.secondLevels.find(
      (secondLevel) => secondLevel.dataset.menu === menu
    )
    activeMenu.classList.add(this.classes.active)
  }

  onSecondLevelClick(e) {
    const { target } = e
    const { menu } = target.dataset
    if (menu) {
      e.preventDefault()

      this.thirdLevels.forEach((thirdLevel) =>
        thirdLevel.classList.remove(this.classes.active)
      )
      const activeMenu = this.thirdLevels.find(
        (thirdLevel) => thirdLevel.dataset.menu === menu
      )
      activeMenu.classList.add(this.classes.active)
      activeMenu.removeAttribute('inert')
      const firstFocusable = activeMenu.querySelector('a')
      firstFocusable.focus()
      target.setAttribute('aria-expanded', 'true')
    }

    this.updateAreaHiddenAttributes();
  }

  onThirdLevelClick(e) {
    const { target } = e
    const { menu } = target.dataset
    if (menu) {
      e.preventDefault()
      this.removeThirdLevelActive()
    }

    this.updateAreaHiddenAttributes();
  }

  removeThirdLevelActive() {
    this.thirdLevels.forEach((thirdLevel) => {
      thirdLevel.classList.remove(this.classes.active)
      thirdLevel.setAttribute('inert', '')
      this.secondLevelsButtons.forEach((button) =>
        button.setAttribute('aria-expanded', 'false')
      )
    })
  }

  updateAreaHiddenAttributes() {
    const activeThirdLevel = this.thirdLevels.find(el =>
      el.classList.contains(this.classes.active)
    );
    const inactiveThirdLevels = this.thirdLevels.filter(el =>
      !el.classList.contains(this.classes.active)
    );

    if (activeThirdLevel) {
      activeThirdLevel.removeAttribute('aria-hidden');
      activeThirdLevel.removeAttribute('inert');
    }

    if (Array.isArray(inactiveThirdLevels)) {
      inactiveThirdLevels.forEach(inactiveThirdLevel => {
        inactiveThirdLevel.setAttribute('aria-hidden', 'true');
        inactiveThirdLevel.setAttribute('inert', '');
      });
    }

    let activeSecondLevel = null;
    let inactiveSecondLevels = this.secondLevels;
    //if third level is active - treat second as inactive
    if (!activeThirdLevel) {
      activeSecondLevel = this.secondLevels.find(el =>
        el.classList.contains(this.classes.active)
      );
      inactiveSecondLevels = this.secondLevels.filter(el =>
        !el.classList.contains(this.classes.active)
      );
    }
   
    if (activeSecondLevel) {
      activeSecondLevel.removeAttribute('aria-hidden');
      activeSecondLevel.removeAttribute('inert');
    }

    if (Array.isArray(inactiveSecondLevels)) {
      inactiveSecondLevels.forEach(inactiveSecondLevel => {
        inactiveSecondLevel.setAttribute('aria-hidden', 'true');
        inactiveSecondLevel.setAttribute('inert', '');
      });
    }
  }

  render() {
    return html`
      <div
        class=${classMap({
          menu: true,
          active: this.open,
        })}
        ?inert=${!this.open}
      >
        <div class="menu-inner">
          <div class="first-level">
            <slot name="first-level" @click=${this.onFirstLevelClick}></slot>
          </div>
          <div class="second-level">
            <slot name="second-level" @click=${this.onSecondLevelClick}></slot>
          </div>
          <div class="third-level">
            <slot name="third-level" @click=${this.onThirdLevelClick}></slot>
          </div>
        </div>
      </div>
    `
  }

  static styles = css`
    @media (min-width: 1024px) {
      :host {
        display: none;
      }
    }

    :host *,
    :host *::before,
    :host *::after {
      box-sizing: border-box;
    }

    .menu {
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      transition: transform var(--hh-duration-x-long),
        top var(--hh-duration-medium);
      transform: translateY(-100%);
      width: 100%;
      z-index: 99;
    }

    .menu.active {
      transform: translateY(0);
      top: var(--hh-total-header-height, 0);
    }

    .menu-inner {
      width: 100%;
      height: 100%;
      background-color: var(--hh-color-day);
      display: flex;
      flex-direction: column;
    }

    ::slotted([slot='first-level']) {
      display: flex;
      justify-content: center;
    }

    ::slotted([slot='first-level']:focus) {
      outline: none !important;
    }

    .first-level {
      flex: 0 0 auto;
      padding: 0 var(--hh-spacing-xl);
      margin: 0 -0.6rem var(--hh-spacing-lg) -0.6rem;
    }

    .second-level {
      flex: 1 1 auto;
      padding: 0 var(--hh-spacing-xl) var(--hh-spacing-xl);
      overflow-y: auto;
      height: 100%;
    }

    .second-level::-webkit-scrollbar {
      width: 0.2rem;
    }
    .second-level::-webkit-scrollbar-thumb {
      width: 0.2rem;
      background: var(--hh-color-brand-primary);
    }
  `
}

if (!customElements.get('hh-mobile-menu')) {
  customElements.define('hh-mobile-menu', HHMobileMenu);
}